import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Image & icon imports
import contactusHeader from '../assets/images/contactus/contactus3.webp';
import tripadvisorLogo from '../assets/images/logo-tripadviser.png';

// CSS imports
import '../assets/css/lineicons.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style2.css';

const ContactUs = () => {
  // State to keep track of which FAQ item is open
  const [openFaqItem, setOpenFaqItem] = useState('collapseOne');

  // Handler for FAQ item clicks
  const handleFaqClick = (id) => {
    setOpenFaqItem(id === openFaqItem ? null : id);
  };

  // Coordinates for Kent Cottage
  const position = [6.9608211, 80.7923476];

  return (
    <div className="example">
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <meta name="theme-color" content="#722628" />
        <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" />
        <title>
          Contact Us | Boutique Hotels and Leisure, Sri Lanka | Oryza Leisure
        </title>
        <meta name="author" content="Ollcode" />
        <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
        <meta name="keywords" content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, vip" />
      </Helmet>
      <Navbar />
      <main id="main">
        <header
          className="page-header"
          style={{
            backgroundImage: `url(${contactusHeader})`,
          }}
        >
          <div className="container">
            <div className="desktopview">
              <h1>HOME AWAY FROM HOME</h1>
            </div>
            <div className="mobileview">
              <h1 style={{lineHeight:'2px'}}>HOME AWAY</h1><br /><h1 style={{lineHeight:'2px'}}>FROM HOME</h1>
            </div>
            <p>Anxiously awaiting your presence</p>
          </div>
          <div className="scroll-down"></div>
        </header>

        <section className="content-section kentbg">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="section-title whitetext">
                  <h6>GIVE US A SHOUT</h6>
                  <h2>Contact us</h2>
                </div>
                <form id="contact">
                  <div className="contact-form">
                    <div className="form-group">
                      <input type="text" id="name" name="name" placeholder="Your Name*" required />
                    </div>
                    <div className="form-group">
                      <input type="text" id="email" name="email" placeholder="Your E-mail*" required />
                    </div>
                    <div className="form-group">
                      <input type="text" name="mobile" id="mobile" placeholder="Phone Number*" required />
                    </div>
                    <div className="form-group">
                      <input type="text" name="hotel" id="hotel" value="kent" style={{ display: 'none' }} readOnly />
                    </div>
                    <div className="form-group">
                      <textarea name="message" id="message" placeholder="Your Message*" required></textarea>
                    </div>
                    <div
                      id="success"
                      className="message success"
                      style={{
                        display: 'none',
                        backgroundColor: 'green',
                        padding: '10px',
                        color: '#ffffff',
                        marginBottom: '10px',
                        borderRadius: '5px',
                      }}
                    >
                      Your message is successfully sent...
                    </div>
                    <div className="form-group">
                      <button type="submit" className="nava-btn--primary nava-btn--md">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-xl-4 offset-xl-1 col-lg-5">
                <div className="contact-box" style={{ background: '#ecdfd7' }}>
                  <h6 style={{ color: '#722628' }}>CALL US</h6>
                  <a className="tel" href="tel:+94767008800" target="_blank" rel="noopener noreferrer" style={{ color: '#722628' }}>
                    <strong>+94 76 700 8800</strong>
                  </a>
                </div>
                <div className="contact-box" style={{ background: '#905d5f' }}>
                  <h6>EMAIL US</h6>
                  <p><strong>reservations@oryzaleisure.com</strong></p>
                </div>
                <div className="contact-box" style={{ background: '#722628' }}>
                  <h6>ADDRESS</h6>
                  <address>
                    <strong>
                      Lot 6<br />
                      Little England Cottages<br />
                      Nuwara Eliya, Sri Lanka 22200
                    </strong>
                  </address>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Leaflet Map Section */}
        <div className="map-section" style={{ height: '600px', width: '100%' }}>
          <MapContainer center={position} zoom={15} style={{ height: '100%', width: '100%' }}>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={position}>
              <Popup>
                Kent Cottage<br />
                Lot 6, Little England Cottages<br />
                Nuwara Eliya, Sri Lanka 22200
              </Popup>
            </Marker>
          </MapContainer>
        </div>
        {/* <div class="google-maps">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3259.087710795762!2d80.789772673998!3d6.960821093039642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae38061e910f2f7%3A0xe60ae72732424953!2sKent%20Cottage!5e1!3m2!1sen!2slk!4v1746605107461!5m2!1sen!2slk" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> </div> */}

        {/* FAQ Section - Updated with React state management */}
        <section className="content-section kentbg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="accordion" id="accordion" role="tablist">
                  {/* FAQ Item 1 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingOne">
                      <a
                        href="#collapseOne"
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseOne');
                        }}
                        className={openFaqItem !== 'collapseOne' ? 'collapsed' : ''}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseOne'}
                        aria-controls="collapseOne"
                      >
                        How far is Kent Cottage from the centre of Nuwara Eliya?
                      </a>
                    </div>
                    <div
                      id="collapseOne"
                      className={`collapse ${openFaqItem === 'collapseOne' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingOne"
                    >
                      <div className="card-body">
                        Kent Cottage is 1.4 km from the centre of Nuwara Eliya. All distances are measured in straight lines. Actual travel distances may vary.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 2 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingTwo">
                      <a
                        href="#collapseTwo"
                        className={openFaqItem !== 'collapseTwo' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseTwo');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseTwo'}
                        aria-controls="collapseTwo"
                      >
                        Does Kent Cottage have a hot tub for its guests?
                      </a>
                    </div>
                    <div
                      id="collapseTwo"
                      className={`collapse ${openFaqItem === 'collapseTwo' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingTwo"
                    >
                      <div className="card-body">
                        Yes, there is a hot tub. You can find out more about this and the other facilities at Kent Cottage on this page.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 3 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingThree">
                      <a
                        href="#collapseThree"
                        className={openFaqItem !== 'collapseThree' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseThree');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseThree'}
                        aria-controls="collapseThree"
                      >
                        How much does it cost to stay at Kent Cottage?
                      </a>
                    </div>
                    <div
                      id="collapseThree"
                      className={`collapse ${openFaqItem === 'collapseThree' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingThree"
                    >
                      <div className="card-body">
                        The prices at Kent Cottage may vary depending on your stay (e.g. dates you select, hotel's policy etc.). See the prices by entering your dates.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 4 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingFour">
                      <a
                        href="#collapseFour"
                        className={openFaqItem !== 'collapseFour' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseFour');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseFour'}
                        aria-controls="collapseFour"
                      >
                        Does Kent Cottage have a terrace?
                      </a>
                    </div>
                    <div
                      id="collapseFour"
                      className={`collapse ${openFaqItem === 'collapseFour' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingFour"
                    >
                      <div className="card-body">
                        Yes, there are options at this property that have a terrace. You can find out more about this and the other facilities at Kent Cottage on this page.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 5 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingFive">
                      <a
                        href="#collapseFive"
                        className={openFaqItem !== 'collapseFive' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseFive');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseFive'}
                        aria-controls="collapseFive"
                      >
                        What is there to do at Kent Cottage?
                      </a>
                    </div>
                    <div
                      id="collapseFive"
                      className={`collapse ${openFaqItem === 'collapseFive' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingFive"
                    >
                      <div className="card-body">
                        Kent Cottage offers the following activities / services (charges may apply):<br />
                        <ul>
                          <li>Hot tub/Jacuzzi</li>
                          <li>Golf course (within 3 km)</li>
                          <li>Walking tours</li>
                          <li>Cooking class</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 6 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingSix">
                      <a
                        href="#collapseSix"
                        className={openFaqItem !== 'collapseSix' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseSix');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseSix'}
                        aria-controls="collapseSix"
                      >
                        What are the check-in and check-out times at Kent Cottage?
                      </a>
                    </div>
                    <div
                      id="collapseSix"
                      className={`collapse ${openFaqItem === 'collapseSix' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingSix"
                    >
                      <div className="card-body">
                        Check-in at Kent Cottage is from 14:00, and check-out is until 12:00.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 7 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingSeven">
                      <a
                        href="#collapseSeven"
                        className={openFaqItem !== 'collapseSeven' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseSeven');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseSeven'}
                        aria-controls="collapseSeven"
                      >
                        Are pets allowed at Kent Cottage?
                      </a>
                    </div>
                    <div
                      id="collapseSeven"
                      className={`collapse ${openFaqItem === 'collapseSeven' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingSeven"
                    >
                      <div className="card-body">
                        Sadly, we do not accommodate pets at Kent Cottage.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 8 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingEight">
                      <a
                        href="#collapseEight"
                        className={openFaqItem !== 'collapseEight' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseEight');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseEight'}
                        aria-controls="collapseEight"
                      >
                        How many guests can sleep at Kent Cottage?
                      </a>
                    </div>
                    <div
                      id="collapseEight"
                      className={`collapse ${openFaqItem === 'collapseEight' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingEight"
                    >
                      <div className="card-body">
                        You can choose from a number of accommodation options at Kent Cottage (subject to availability). These can accommodate:
                        <ul>
                          <li>11 guests</li>
                          <li>4 guests</li>
                        </ul>
                        For more detailed information, please check the accommodation option(s) breakdown on this page.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 9 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingNine">
                      <a
                        href="#collapseNine"
                        className={openFaqItem !== 'collapseNine' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseNine');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseNine'}
                        aria-controls="collapseNine"
                      >
                        How many bedrooms does Kent Cottage have?
                      </a>
                    </div>
                    <div
                      id="collapseNine"
                      className={`collapse ${openFaqItem === 'collapseNine' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingNine"
                    >
                      <div className="card-body">
                        You can choose from a number of accommodation options at Kent Cottage (subject to availability). These have:
                        <ul>
                          <li>2 bedrooms</li>
                          <li>4 bedrooms</li>
                        </ul>
                        For more detailed information, please check the accommodation option(s) breakdown on this page.
                      </div>
                    </div>
                  </div>

                  {/* FAQ Item 10 */}
                  <div className="card">
                    <div className="card-header" role="tab" id="headingTen">
                      <a
                        href="#collapseTen"
                        className={openFaqItem !== 'collapseTen' ? 'collapsed' : ''}
                        onClick={(e) => {
                          e.preventDefault();
                          handleFaqClick('collapseTen');
                        }}
                        style={{ cursor: 'pointer' }}
                        aria-expanded={openFaqItem === 'collapseTen'}
                        aria-controls="collapseTen"
                      >
                        Is Kent Cottage popular with families?
                      </a>
                    </div>
                    <div
                      id="collapseTen"
                      className={`collapse ${openFaqItem === 'collapseTen' ? 'show' : ''}`}
                      role="tabpanel"
                      aria-labelledby="headingTen"
                    >
                      <div className="card-body">
                        Yes, Kent Cottage is popular with guests booking family stays.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing desktopview" style={{ background: '#905d5f' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bar">
                  <i className="lni lni-protection"></i>
                  <h6>View our reviews from our previous guest on</h6>
                  <a
                    href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong style={{ color: '#fff' }}>Tripadvisor</strong>
                  </a>
                  <figure>
                    <a
                      href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={tripadvisorLogo} alt="Tripadvisor reviews of Kent Cottage" />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <style>
        {`
          .page-header {
            position: relative;
            height: 60vh;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: left;
            color: white;
          }
            .page-header:after {
  content: "";
  width: 100%;
  height: 100%;
  background: #000;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.5;
}

          .page-header .container {
            padding: 20px;
            max-width: 1200px;
            margin: 0 auto;
          }

          .page-header .container h1 {
            width: 100%;
            display: block;
            font-size: 48px;
            font-weight: 300;
            margin-bottom: 10px;
            line-height: 1.2;
            font-family: "Argesta Display";
            text-indent: 130px;
          }

          .page-header .container p {
            font-size: 22px;
            font-weight: 300;
            margin: 0;
            line-height: 1.5;
            text-indent: 130px;
          }

          .scroll-down {
            position: absolute;
            bottom: 20px;
            width: 2px;
            height: 40px;
            background: white;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);
          }

          @media (max-width: 768px) {
            .page-header {
              height: 60vh;
              background-size: cover !important;
              background-position: center;
            }

            .page-header .container h1 {
              font-size: 24px;
              line-height: 1.2;
              text-indent: 50px;
            }

            .page-header .container p {
              font-size: 0.9rem;
              line-height: 1.5;
              text-indent: 50px;
            }
          }

          /* Ensure map container has proper dimensions */
          .map-section {
            position: relative;
            width: 100%;
            height: 600px;
          }
        `}
      </style>
    </div>
  );
};

export default ContactUs;